import React from "react";

export const Button = ({ onClick, caracter, value, addSearch, title }) => {
  const isDecrement = caracter === "-";
  const isAdults = title === "Adultos";

  // 🔧 ARREGLAR: Mejorar la lógica de deshabilitación
  const isDisabled =
    isDecrement &&
    ((isAdults && value <= 1) || (!isAdults && value <= 0));

  return (
    <button
      aria-label={`${isDecrement ? "decrementar" : "incrementar"} ${title.toLowerCase()}`}
      disabled={isDisabled}
      style={{
        fontSize: `${caracter === "-" ? "32px" : "24px"}`,
        lineHeight: "1",
        // 🔧 ARREGLAR: Asegurar que el botón sea clickeable
        pointerEvents: isDisabled ? "none" : "auto",
        opacity: isDisabled ? 0.5 : 1,
      }}
      className={
        addSearch
          ? `sm:text-[1em] RobotoBold`
          : `sm:text-[2vw] RobotoBold`
      }
      onClick={(e) => {
        // 🔧 ARREGLAR: Prevenir propagación y asegurar que el click funcione
        e.preventDefault();
        e.stopPropagation();
        if (!isDisabled) {
          onClick();
        }
      }}
    >
      {caracter}
    </button>
  );
};

const AdultsAndChild = ({ title, setValue, value, addSearch }) => {
  // 🔧 ARREGLAR: Funciones de incremento/decremento más robustas
  const handleIncrement = () => {
    setValue(value + 1);
  };

  const handleDecrement = () => {
    const isAdults = title === "Adultos";
    const minValue = isAdults ? 1 : 0;

    if (value > minValue) {
      setValue(value - 1);
    }
  };

  return (
    <div
      className={`flex flex-row-reverse items-center justify-center sm:justify-start
         sm:h-full gap-3 flex-end sm:flex-start sm:flex-col ${
           addSearch ? "sm:gap:0 h-[32px]" : ""
         }`}
    >
      <strong
        className={`p-0 font-extrabold MainInputSearch__container__label sm:grid ${
          addSearch && "sm:text-[.8rem] flex flex-col"
        }`}
      >
        {title}
      </strong>
      <span
        className={`flex items-center h-[23vw] gap-2 ${
          addSearch ? "h-[24px] mt-[-10px]" : ""
        }`}
      >
        <Button
          title={title}
          onClick={handleDecrement}
          caracter={"-"}
          addSearch={addSearch}
          value={value}
        />
        <strong
          className={
            addSearch
              ? "text-[6vw] sm:text-[1rem] RobotoBold"
              : "text-[6vw] sm:text-[2vw] RobotoBold"
          }
        >
          {value}
        </strong>
        <Button
          title={title}
          onClick={handleIncrement}
          caracter={"+"}
          value={value}
          addSearch={addSearch}
        />
      </span>
    </div>
  );
};

export default AdultsAndChild;
